import { render, staticRenderFns } from "./BaseNotAuthenticatedPage.vue?vue&type=template&id=4f55bd85"
import script from "./BaseNotAuthenticatedPage.vue?vue&type=script&lang=js"
export * from "./BaseNotAuthenticatedPage.vue?vue&type=script&lang=js"
import style0 from "./BaseNotAuthenticatedPage.vue?vue&type=style&index=0&id=4f55bd85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports